<template>
	<div class="uploadImg">
		<div class="img-div">
			<div v-for="(list, index) in uploadImgList" style="display: inline-block;" :key='index'>
				<div style="position: relative;" @click="onSeeOrDel(list)">
					<img src="../assets/attach.png" class="upload-img-style"/>
					<img src="../assets/star.png" v-if="smallDelIco" class="upload-img-del">
				</div>
			</div>
		</div>
		<span class="attach-icon-minus r35" v-if="delImgIconShow && uploadImgState" @click="onDelClick()"></span>
		<span class="r35 t10" style="position: absolute;" v-if="uploadImgList.length > 0 && smallDelIco"
			@click="onFinishClick">完成</span>
		<span class="attach-icon-plus" :class="{'t0': uploadImgList.length === 0}" v-if="addImgIconShow && uploadImgState" @click="onAttachAdd()"></span>
		<input type="file" ref="attachInput" name="file" accept="image/*" style="display: none" @change="attachBeforeUpload($event)"/>
	</div>
</template>
<script>
export default {
	props: {
		uploadImgList: {
			type: Array,
			default: () => {
				return []
			}
		},
		smallDelIco: {
			type: Boolean,
			default: false
		},
		billState: {
			type: Number,
			default: 0
		},
		imgListLength: {
			type: Number,
			default: 10
		},
		imgSizeMaxLength: {
			type: Number,
			default: 5
		},
		uploadImgState: {
			type: Boolean,
			default: true
		},
		jumpBill: Boolean
	},
	data () {
		return {
		}
	},
	computed: {
		delImgIconShow () {
			return this.uploadImgList.length > 0 && !this.smallDelIco && this.billState !== 12 && this.billState !== 13 && !this.jumpBill
		},
		addImgIconShow () {
			return this.billState !== 12 && this.billState !== 13 && !this.jumpBill
		}
	},
	methods: {
		onDelClick () {
			this.$emit('update:smallDelIco', !this.smallDelIco)
		},
		onFinishClick () {
			this.$emit('update:smallDelIco', !this.smallDelIco)
		},
		onAttachAdd () {
			if (this.uploadImgList.length < this.imgListLength) {
				this.$refs.attachInput.click()
			} else {
				this.$fxToast.warning(`只能上传${this.imgListLength}个附件`)
				return false
			}
		},
		onSeeOrDel (img) {
			if (this.smallDelIco) {
				this.attachDel(img.id)
			} else {
				this.attachClick(img.path)
			}
		},
		attachDel (imgId) {
			this.$fxConfirmSheet({message: '确定要删除附件吗？', btns: ['确定', '取消']}).then(() => {
				this.$emit('attachDelPost', imgId, this.$refs.attachInput)
			})
		},
		/* 点击预览图片 */
		attachClick (url) {
			// this.$refs.itemImgRef.open(url)
			this.$emit('attachClick', url)
		},
		// 上传图片
		attachBeforeUpload (e) {
			let attachFile = this.$refs.attachInput.files[0]
			if (attachFile.size > this.imgSizeMaxLength * 1024 * 1024) {
				this.$fxToast.warning(`文件大小不能超过${this.imgSizeMaxLength}MB`)
				return false
			}
			this.$emit('attachBeforeUpload', attachFile, this.$refs.attachInput)
		}
	}
}
</script>



// WEBPACK FOOTER //
// Upload.vue?53aca191